import type { AppButtonProps } from "@/shared/Components/AppButton";
import type { ConnectionsTableColumnsKeys, ConnectionsTableProps } from "../model";
import { SettingsTitle } from "../ui/SettingsTitle";
import { getConnectionsTableTitles } from "../model/constants";

type Props = {
  columns: ConnectionsTableProps["columns"];
  columnsKeys: ConnectionsTableColumnsKeys[];
  settingsButtonOnClick: AppButtonProps["onClick"];
};

export const buildConnectionsColumns = ({
  columns,
  columnsKeys,
  settingsButtonOnClick,
}: Props): ConnectionsTableProps["columns"] => {
  const resultColumns = columnsKeys.flatMap((item) => {
    const lastColumnKey = columnsKeys[columnsKeys.length - 1];
    const targetColumn = columns.find((baseColumn) => baseColumn?.key === item);
    if (!targetColumn) return [];
    if (lastColumnKey === targetColumn?.key) {
      targetColumn.title = (
        <SettingsTitle
          title={getConnectionsTableTitles()[targetColumn.key]}
          onClick={settingsButtonOnClick}
        />
      );
    } else {
      targetColumn.title =
        getConnectionsTableTitles()[
          targetColumn.key as keyof ReturnType<typeof getConnectionsTableTitles>
        ] ?? "";
    }
    return targetColumn || [];
  });
  return resultColumns;
};
